import {
	ChangeDetectionStrategy,
	Component,
} from "@angular/core";
import {EdLoaderConfig, EdLoaderModule} from "@edenred/components/loader";

@Component({
	selector: "er-block-ui",
	templateUrl: "./block-ui.component.html",
	styleUrls: ["./block-ui.component.scss"],
	imports: [
		EdLoaderModule
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true
})
export class BlockUiComponent {

	public readonly edLoaderConfig: EdLoaderConfig = {
		dotSize: 8,
		ellipsisBackgroundColor: "red"
	};
}